// removed by extract-text-webpack-plugin
module.exports = {"infoPanelText":"src-pages-kontakt----kontakt-module---infoPanelText---3FptY","infoPanel":"src-pages-kontakt----kontakt-module---infoPanel---2qBlk","header":"src-pages-kontakt----kontakt-module---header---11yOO","trenerjiContainer":"src-pages-kontakt----kontakt-module---trenerjiContainer---2duze"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/kontakt/kontakt.module.css
// module id = 576
// module chunks = 65264405719262